import React from "react";
import { LoadingSpinnerSize } from "types/loadingSpinner";

import LoadingSpinner from "./LoadingSpinner";
import styles from "./ModalLoading.module.scss";

interface Props {
    onBackDropClick?: () => void;
}

const ModalLoading = ({ onBackDropClick = () => {} }: Props) => {
    const backdrop = (
        <div
            className={styles["modal-loading__back-drop"]}
            onClick={onBackDropClick}
            role="presentation"
        />
    );
    return (
        <>
            <div role="presentation" onClick={onBackDropClick} className={styles["modal-loading"]}>
                <LoadingSpinner absoluteCenter size={LoadingSpinnerSize.large} />
            </div>
            {backdrop}
        </>
    );
};

export default ModalLoading;
